// @flow

import { type IncomingPayment } from '../types';
import { normalizeCustomerIncomingPayment } from '@tectonics/prs/core/customer/normalize';

export function normalizeIncomingPayment<T: IncomingPayment>(incomingPayment: T): T {
  return normalizeCustomerIncomingPayment<T>(incomingPayment);
}
